import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Articulo } from "@/shared/types/articulo"; 
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ArticulosQuery extends BaseQuery {
    codigo?: string,
    numeroItem?: string,
    nombre?: string,
    rubroId?: string
}

export async function getAllArticulos(query?: ArticulosQuery): Promise<QueryResponse<Articulo>> {
    await sleep(1000);
    const response = await api.get("articulos", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllArticulosQuery(query: ArticulosQuery = {}, queryConfig: QueryConfig<QueryResponse<Articulo>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllArticulos(query),
        queryKey: ["articulos", query],
    })
}

export interface GetAllArticulosQueryProps{
    query:ArticulosQuery,
    queryConfig?: QueryConfig<QueryResponse<Articulo>>,
    children:(queryResult:QueryResult<QueryResponse<Articulo>>)=>ReactNode
}

export function GetAllArticulosQuery({
    query,
    queryConfig,
    children
}:GetAllArticulosQueryProps){
    const queryResult = useGetAllArticulosQuery(query, queryConfig);
    return children&&children(queryResult);
}